// An assignment ("ödev") lives on two INDEPENDENT axes:
//   • the availability WINDOW  — upcoming → open → expired, from beginAt/endAt
//   • the learner's PROGRESS   — not-started → in-progress → completed (backend completionStatus)
// The WINDOW dominates progress: a future beginAt is UPCOMING ("Yakında", cannot be started
// yet) and a past endAt is EXPIRED ("Süresi doldu", can no longer be worked on), regardless
// of progress — only an in-window assignment surfaces a progress-based badge. A COMPLETED
// assignment stays "done" even once its window closes.
//
// The dashboard card (common/dashboards/Homework) maps its badge + CTA from this helper. The
// /homeworks list (learner/views/HomeworkApplicationListView) and the assignment intro/detail
// (learner/transitions/ContentTransition, screens .../BranchAssignmentScreen) apply the
// SAME beginAt/endAt boundaries but for their own richer window UI (a "Süresi doldu" tag, a
// countdown banner, mascot gating) rather than a single badge — so this is the shared rule for
// the WINDOW→badge mapping, not the only place beginAt/endAt is read.
export type AssignmentStatusKind =
  | "upcoming"
  | "expired"
  | "new"
  | "ongoing"
  | "done"
  | "timeup";

export const retrieveAssignmentStatusKind = (
  completionStatus: string | null | undefined,
  beginAt: number | null | undefined,
  endAt: number | null | undefined,
  now: number = Date.now(),
): AssignmentStatusKind => {
  // Window dominates progress: a future beginAt means the learner literally cannot start
  // yet; a past endAt means the window has closed. A finished assignment stays "done".
  if (beginAt != null && beginAt > now) return "upcoming";
  if (completionStatus === "COMPLETED") return "done";
  if (endAt != null && endAt <= now) return "expired";
  if (completionStatus === "TIME_UP") return "timeup";
  if (completionStatus === "ON_GOING") return "ongoing";
  return "new";
};
